/*
 * Copyright 2025 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { consola } from "consola";
export function logWidgetSetCommandConfigFileOverride(args, config) {
  if (config?.widgetSet.rid != null && args.widgetSet !== config.widgetSet.rid) {
    consola.debug(`Overriding "rid" from config file with ${args.widgetSet}`);
  }
  if (config?.foundryUrl != null && args.foundryUrl !== config.foundryUrl) {
    consola.debug(`Overriding "foundryUrl" from config file with ${args.foundryUrl}`);
  }
}